const toolbarOptions = [
  [{ 'size': ['small', false, 'large', 'huge'] }],
  [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
  ['bold', 'italic', 'underline', 'strike'],
  [{ 'list': 'ordered'}, { 'list': 'bullet' }],

  [{ 'color': [] }, { 'background': [] }],
  [{ 'font': ['arial', 'verdana', 'calibri',
      'roboto', 'times-new-roman', 'tahoma'] }],
  [{ 'align': [] }],

  ['clean']
];

export const editorModules = {
  toolbar: toolbarOptions
}
